/**
 * The Base JS module that kickstarts the JS for the JE website
 */

import 'babel-polyfill';

import ready from 'lite-ready';

import './es6/shims/polyfill.io'; // polyfills from polyfill.io
import './es6/shims/extra'; // Any extra polyfills we need in addition to polyfill.io
import './libs/picturefill.min'; // picturefill polyfill
import baseInit from './es6';

// this kicks off when the page is ready
ready(() => {

    baseInit();

});

